import React, { useState, useEffect, useRef } from 'react';
import './ContextMenu.css';

function ContextMenu({ x, y, onClose, items }) {
  const [activeSubmenu, setActiveSubmenu] = useState(null);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        onClose();
      }
    };

    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [onClose]);

  const handleItemClick = (item) => {
    if (item.submenu) {
      setActiveSubmenu(activeSubmenu === item.id ? null : item.id);
    } else if (item.onClick) {
      item.onClick();
      onClose();
    }
  };

  const handleSubmenuClick = (subItem) => {
    // Build 27 (item 6): always collapse the submenu AND close the whole
    // context menu when a submenu leaf is chosen. Previously the action
    // fired but the open submenu could linger visually (e.g. when the
    // action opened a modal), which was confusing. Clearing activeSubmenu
    // before onClose guarantees no phantom submenu remains if the menu
    // is reused.
    setActiveSubmenu(null);
    if (subItem.onClick) {
      subItem.onClick();
    }
    onClose();
  };

  return (
    <div
      ref={menuRef}
      className="context-menu"
      style={{ left: `${x}px`, top: `${y}px` }}
    >
      {items.map((item) => (
        <div
          key={item.id}
          className="context-menu-item-wrapper"
          onMouseLeave={() => item.submenu && setActiveSubmenu(prev => prev === item.id ? null : prev)}
        >
          <div
            className={`context-menu-item ${item.submenu ? 'has-submenu' : ''}`}
            onClick={() => handleItemClick(item)}
            onMouseEnter={() => item.submenu && setActiveSubmenu(item.id)}
          >
            {item.icon && <span className="context-menu-icon">{item.icon}</span>}
            <span className="context-menu-label">{item.label}</span>
            {item.submenu && <span className="context-menu-arrow">›</span>}
          </div>

          {item.submenu && activeSubmenu === item.id && (
            <div className="context-submenu">
              {item.submenu.map((subItem) => (
                <div
                  key={subItem.id}
                  className="context-menu-item"
                  onClick={() => handleSubmenuClick(subItem)}
                >
                  {subItem.icon && <span className="context-menu-icon">{subItem.icon}</span>}
                  <span className="context-menu-label">{subItem.label}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

export default ContextMenu;
